module.exports = __webpack_public_path__ + "img/william-seward.fa4a41f9.png";